<template>
  <li
    ref="expandableItemElement"
    class="nav-expandable-item"
    @keydown.esc="close"
    @mouseenter="!isAccordion && open()"
    @focusout="onFocusOut"
    @mouseleave="!isAccordion && close()"
  >
    <button
      type="button"
      class="nav-expandable-item__button-toggle"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="toggle"
    >
      <span class="nav-expandable-item__label"><slot /></span>

      <dpc-icon icon="arrow-up" class="nav-expandable-item__icon" decorative />
    </button>

    <u-transition-height v-if="isAccordion">
      <div v-if="isOpen" class="nav-expandable-item__content">
        <slot name="content" />
      </div>
    </u-transition-height>
    <div v-else-if="isOpen" class="nav-expandable-item__content">
      <slot name="content" />
    </div>
  </li>
</template>

<script>
import { uuid } from 'vue-uuid';
import { ref, inject, computed } from 'vue';
import { useStore } from 'vuex';
import uTransitionHeight from '../../_utilities/u-transition-height.vue';

export default {
  components: { uTransitionHeight },
  setup() {
    const store = useStore();
    const id = uuid.v1();
    const activeItem = inject('activeItem');
    const updateActiveItem = inject('updateActiveItem');

    const isOpen = computed({
      get() {
        return activeItem.value === id;
      },
      set(isOpen) {
        updateActiveItem(isOpen ? id : undefined);
      },
    });
    const isAccordion = computed(() => {
      return !store.getters['window/breakpointUp']('navigation');
    });

    const toggle = () => {
      isOpen.value = !isOpen.value;
    };

    const open = () => {
      isOpen.value = true;
    };

    const close = () => {
      isOpen.value = false;
    };

    const expandableItemElement = ref(null);

    const onFocusOut = event => {
      if (expandableItemElement.value.contains(event.relatedTarget)) return;
      close();
    };

    return {
      isAccordion,
      isOpen,
      toggle,
      open,
      close,
      onFocusOut,
      expandableItemElement,
    };
  },
};
</script>
